import createLogger from "v2/Utils/logger"

export const logger = createLogger("v2/Components/Inquiry")
